module.exports = __webpack_public_path__ + "img/yz_bank.1093cd57.png";